import { IAttribute } from "../../model/formconfiguration/Attribute";
import { IFormType } from "../../model/formconfiguration/FormType";
import { IQualifier } from "../../model/formconfiguration/Qualifier";
import { ISection } from "../../model/formconfiguration/Section";
import { IHttpService } from "../HttpService";
import AttributeListMapper from "./Mappers/AttributeListMapper";
import FormConfigurationDetailsMapper from "./Mappers/FormConfigurationDetailsMapper";
import QualifierListMapper from "./Mappers/QualifierListMappers";

export interface IFormConfigurationService {
  getFormConfigurationDetails(
    formTypeCode: string
  ): Promise<{
    formType: IFormType;
    formSections: ISection[];
    qualifiers: IQualifier[];
    attributes: IAttribute[];
  }>;
}

const FormConfigurationService = (httpService): IFormConfigurationService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api";
  const _formConfigurationPath = "/form-configuration";
  const _formTypesPath = "/form-types";
  const _detailsPath = "/details";

  return {
    async getFormConfigurationDetails(formTypeCode: string) {
      const path = _http.buildPath(
        _baseUrl,
        _formConfigurationPath,
        _formTypesPath,
        formTypeCode,
        _detailsPath
      );
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);

      let {
        formType,
        formSections,
        formSectionQualifiers,
        formQualifierAttributes,
        qualifiers,
        attributes
      } = await responseJSON;

      qualifiers = QualifierListMapper(qualifiers);
      attributes = AttributeListMapper(attributes);

      formSections = FormConfigurationDetailsMapper(
        formSections,
        formSectionQualifiers,
        formQualifierAttributes,
        qualifiers,
        attributes
      );

      return {
        formType,
        formSections,
        qualifiers,
        attributes
      };
    }
  };
};

export default FormConfigurationService;
